"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentHeader = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _DocumentStyledComponents = require("./DocumentStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const DocumentHeader = props => {
  const {
    documentType,
    label,
    requiredDocument
  } = props;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const description = documentType?.description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
    title: documentType.description,
    enterTouchDelay: 0,
    leaveTouchDelay: 5000,
    ...getTestIdProps('document-description-tooltip'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledHelpCircle, {})
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledDivHeader, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentStyledComponents.StyledLabel, {
      children: [label, requiredDocument ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledRequiredDocument, {
        children: "*"
      }) : null, description]
    })
  });
};
exports.DocumentHeader = DocumentHeader;